import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RequestShowEditRoutingModule } from './request-show-edit-routing.module';
import { RequestShowEditComponent } from './request-show-edit.component';
import { RequestsSharedModule } from '../@shared';
import { MaterialModule } from '@app/material.module';
import { RequestModule } from '../request/request.module';
import { RequestAutoModule } from '../request-auto/request-auto.module';
import { RequestBpModule } from '../request-bp/request-bp.module';
import { RequestMgModule } from '../request-mg/request-mg.module';
import { RequestMgNoShoppingModule } from '../request-mg-no-shopping/request-mg-no-shopping.module';

@NgModule({
  declarations: [RequestShowEditComponent],
  imports: [
    CommonModule,
    RequestShowEditRoutingModule,
    RequestsSharedModule,
    MaterialModule,
    RequestModule,
    RequestAutoModule,
    RequestBpModule,
    RequestMgModule,
    RequestMgNoShoppingModule,
  ],
})
export class RequestShowEditModule {}
